"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodePowerSymbol = decodePowerSymbol;
exports.decodeComponentInstance = decodeComponentInstance;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const helpers_1 = require("../helpers");
const entity_list_1 = require("./entity-list");
const typeCodes_1 = require("../typeCodes");
const decode_prop_block_1 = require("./decode-prop-block");
const decode_tc13_terminal_1 = require("./decode-tc13-terminal");
const decode_tc31_visual_label_1 = require("./decode-tc31-visual-label");
function decodePowerSymbol(node, path, warnings) {
    if (!isContainer(node)) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:7 (PowerSymbol), got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    if (node.children.length !== 19) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `tc:7 (PowerSymbol) has ${node.children.length} children, expected 19`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const common = decodeInstanceCommon(node, path, warnings);
    const associatedNetStubId = (0, decode_prop_block_1.findPropValue)(common.props, 'CDS_ASSOC_NET_ID_STR');
    return {
        kind: 'power-symbol',
        flavor: 'tc7-power-symbol',
        associatedNetStubId,
        ...common,
        raw: node,
    };
}
function decodeComponentInstance(node, path, warnings, instanceHashMap, pageNum) {
    if (!isContainer(node)) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:12 (ComponentInstance), got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    if (node.children.length !== 19) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `tc:12 (ComponentInstance) has ${node.children.length} children, expected 19`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const common = decodeInstanceCommon(node, path, warnings);
    let resolvedInstanceId = null;
    if (common.placementHash !== null && instanceHashMap !== null && pageNum !== null) {
        const found = instanceHashMap.get(`${pageNum}:${common.placementHash}`);
        resolvedInstanceId = found === undefined ? null : found;
        if (resolvedInstanceId === null) {
            warnings.push({
                type: decoded_types_1.DecodeWarningType.CrossRefMiss,
                message: `tc:12 (ComponentInstance) placement (page=${pageNum}, hash=${common.placementHash}) not found in master.instanceHashMap`,
                severity: sigma_engine_shared_1.BoundaryLevel.Warning,
                path: `${path}/placementHash`,
            });
        }
    }
    return {
        kind: 'component-instance',
        flavor: 'tc12-component',
        resolvedInstanceId,
        rotation: (0, decode_prop_block_1.findPropValue)(common.props, 'rotation'),
        transform: (0, decode_prop_block_1.findPropValue)(common.props, 'transform'),
        zValue: (0, decode_prop_block_1.findPropValue)(common.props, 'zValue'),
        ...common,
        raw: node,
    };
}
function decodeInstanceCommon(node, path, warnings) {
    const c = node.children;
    const libId = (0, helpers_1.findPrefixed)(c, '14');
    const modelRef = (0, helpers_1.findPrefixed)(c, '15');
    const bbox = (0, decode_tc31_visual_label_1.readCoordsContainer)(c[6]);
    const placementHashAtom = c[10];
    const placementHash = placementHashAtom.type === 'atom' ? placementHashAtom.content.trim() : null;
    const placementHashPrefix = placementHash === null ? null : placementHash.slice(0, 3);
    const position = (0, decode_tc31_visual_label_1.readCadencePosition)(c[12]);
    const preamble = [
        c[13]?.type === 'atom' ? c[13].content.trim() : null,
        c[14]?.type === 'atom' ? c[14].content.trim() : null,
        c[15]?.type === 'atom' ? c[15].content.trim() : null,
    ];
    const styleRowIndex = preamble[2] !== null && /^\d+$/.test(preamble[2]) ? preamble[2] : null;
    const terminals = buildTerminalsList(c[4], `${path}/terminals`, warnings);
    const visualLabels = buildVisualLabelsList(c[17], `${path}/visualLabels`, warnings);
    const props = (0, decode_prop_block_1.decodePropBlock)(c[18], `${path}/props`, warnings);
    return {
        libId,
        modelRef,
        bbox,
        position,
        placementHash,
        placementHashPrefix,
        preamble,
        styleRowIndex,
        terminals,
        visualLabels,
        props,
    };
}
function buildTerminalsList(node, path, warnings) {
    return (0, entity_list_1.decodeEntityList)(node, typeCodes_1.TypeCode.Terminal, path, warnings, (item, _i, itemPath) => (0, decode_tc13_terminal_1.decodeTerminal)(item, itemPath, warnings));
}
function buildVisualLabelsList(node, path, warnings) {
    return (0, entity_list_1.decodeEntityList)(node, typeCodes_1.TypeCode.VisualLabel, path, warnings, (item, _i, itemPath) => (0, decode_tc31_visual_label_1.decodeVisualLabel)(item, itemPath, warnings));
}
function isContainer(node) {
    void helpers_1.findPrefixedDeep;
    return node.type === 'container' || node.type === 'econtainer';
}
//# sourceMappingURL=decode-tc7-tc12.js.map